// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#card[data-v-1cee24fb] {\n    border: 1px solid #000;\n}\n#card_selected[data-v-1cee24fb] {\n    border: 1px solid #000080;\n    color: '#fff';\n}\n", ""]);
// Exports
module.exports = exports;
